import { render, staticRenderFns } from "./ServiceDataManagement.vue?vue&type=template&id=2cda6e47&scoped=true&"
import script from "./ServiceDataManagement.vue?vue&type=script&lang=js&"
export * from "./ServiceDataManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cda6e47",
  null
  
)

export default component.exports